<template>
  <AuthLayout :wait-for-brand-panel="false" data-testid="logout-complete">
    <AuthLoginLogo />
    <div class="logout-complete__body">
      <h1 class="logout-complete__title">Signed out</h1>
      <p class="logout-complete__subtitle">You have been signed out successfully.</p>
      <v-btn
        color="primary"
        block
        elevation="0"
        class="logout-complete__submit"
        to="/"
        data-testid="logout-complete__back-to-login"
      >
        <span>Back to login</span>
      </v-btn>
    </div>
  </AuthLayout>
</template>

<script>
import AuthLayout from './components/AuthLayout.vue';
import AuthLoginLogo from './components/AuthLoginLogo.vue';

export default {
  name: 'LogoutComplete',
  components: {
    AuthLayout,
    AuthLoginLogo,
  },
  created() {
    console.info({ message: 'Logout', meta: { success: true } });
    this.$store.dispatch('auth/clearSession');
  },
};
</script>

<style lang="scss" scoped>
@import './LogoutComplete.scss';
</style>
